import { Component, computed, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { TextField } from '@core/jss-proxy';
import { getField } from '@core/jss-utils';
import { SimpleUspComponent } from '@content/ui/usps';

@Component({
  selector: 'wl-simple-usp-container',
  templateUrl: './simple-usp.container.component.html',
  standalone: true,
  imports: [SimpleUspComponent],
})
export class SimpleUspContainerComponent {
  readonly rendering = input.required<InnogyComponentRendering>();

  readonly fields = computed(() => this.rendering().fields);
  readonly usp1 = computed(() => getField<TextField>(this.fields(), 'usp1'));
  readonly usp2 = computed(() => getField<TextField>(this.fields(), 'usp2'));
  readonly usp3 = computed(() => getField<TextField>(this.fields(), 'usp3'));
  readonly usp4 = computed(() => getField<TextField>(this.fields(), 'usp4'));
}
